import { Course } from '@thro-types/core';
import { StudentJobOffer } from '@thro-types/jobmarket';
import { ShibUser } from '@thro-types/users';

import { TFunction } from 'i18next';
import { z } from 'zod';

import { translations } from 'locales/i18n';

export const studentJobOfferValidationSchema = (t: TFunction<'translation', undefined>) =>
  z.object({
    id: z.string().optional(),
    name: z.string().min(1, { message: t(translations.validation.required()) }),
    email: z
      .string()
      .email({ message: t(translations.validation.email()) })
      .min(1, { message: t(translations.validation.required()) }),
    courseId: z.number({ message: t(translations.validation.required()) }),
    jobTypeId: z.number({ message: t(translations.validation.required()) }),
    phone: z.string().optional(),
    startDate: z.date({ message: t(translations.validation.required()) }),
    title: z
      .string()
      .max(100, { message: t(translations.validation.max(), { max: 100 }) })
      .min(1, { message: t(translations.validation.required()) }),
    description: z
      .string()
      .min(1, { message: t(translations.validation.required()) })
      .refine(value => value !== '<p><br></p>', {
        message: t(translations.validation.required())
      }),
    accepted: z.literal(true)
  });

export const studentJobOfferInitalValues = (
  initialOffer: StudentJobOffer | undefined,
  user: ShibUser & { courses: Course[] }
) => {
  return initialOffer
    ? {
        id: initialOffer.id,
        name: initialOffer.name ? initialOffer.name : '',
        email: initialOffer.email ? initialOffer.email : '',
        phone: initialOffer.phone ? initialOffer.phone : '',
        courseId: user.courses.find(c => c.shorthand === initialOffer.course?.shorthand)?.id,
        course: initialOffer.course,
        jobTypeId: initialOffer.jobTypeId,
        startDate: new Date(initialOffer.startDate),
        title: initialOffer.title,
        description: initialOffer.description ? initialOffer.description : '',
        accepted: true
      }
    : {
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        phone: '',
        courseId: user.courses[0]?.id || 0,
        jobTypeId: '',
        startDate: new Date(),
        title: '',
        description: '',
        accepted: false
      };
};
